var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outlet page"},[_c('UiFilterbar',{on:{"onFilterDay":_vm.onDefaultFilter,"onChangeOutlet":_vm.onChangeOutlet}}),_c('UiTable',{attrs:{"timeType":_vm.filterType,"reportData":_vm.report,"colsData":_vm.cols}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }